export type Urgency = "Immediate" | "Within30Days" | "Next3Months";

interface UrgencyData {
    color: string;
    label: string;
}

export const UrgencyMapping: Record<Urgency, UrgencyData> = {
    "Immediate": { color: "text-bg-danger", label: "Immediate" },
    "Within30Days": { color: "text-bg-warning", label: "Next 30 days" },
    "Next3Months": { color: "text-bg-success", label: "Next 3 months" }
};

export type LeadStatus = "Draft" | "Purchased" | "Active" | "InActive" | "Verified" | "Approved";

export interface PurchaseRequestProductDetails {
    id?: string;
    productName: string;
    quantity: number;
    orderValue: number;
    unit: string;
    urgency: Urgency;
    categoryId: number | string;
    parentCategoryName?: string;
    createdUserName?: string;
    address: string;
    createdDateTime?: Date;
    status?: LeadStatus,
    latitude?: number;
    longitude?: number;
    calculatedAmount?: string;
    description?: string;
    brandPreference?: string;
    technicalSpecifications?: string;
    budgetRange?: string;
    scopeOfWork?: string;
};